import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { IBudgetsSettings } from 'types/BudgetsSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useBudgetsSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof IBudgetsSettings>(keysAndPayloads: { key: K; payload: IBudgetsSettings[K] }[]) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.budgets);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('budgets', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
